import React, { Suspense } from 'react';
import lazyWithRetry from 'utils/lazyWithRetry';
import Login from 'pages/login/Login';
import NotFound from 'components/404';
import Loader from 'wrapper/loader';

const BorrowerProfile = lazyWithRetry(() => import('pages/borrower-profile-officer'));
const PipelineAdmin = lazyWithRetry(() => import('pages/pipeline-admin'));
const Admin = lazyWithRetry(() => import('pages/admin'));
const Dashboard = lazyWithRetry(() => import('pages/dashboard-admin'));
const Reports = lazyWithRetry(() => import('pages/reports-admin/reports'));
const Tools = lazyWithRetry(() => import('pages/tools-admin'));
const QuickPrice = lazyWithRetry(() => import('pages/quickPrice'));
const EmployeeOnboard = lazyWithRetry(() => import('pages/auth/EmployeeOnboard'));
const ActivityLog = lazyWithRetry(() => import('pages/activity-log'));

const adminRoutes = [
  {
    path: '/',
    element: <Login />,
    children: [
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Dashboard />
          </Suspense>
        ),
        children: [],
      },
      {
        path: ':param/lead',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <BorrowerProfile />
          </Suspense>
        ),
      },
      {
        path: 'pipeline',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <PipelineAdmin />
          </Suspense>
        ),
      },
      {
        path: 'onboard',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <EmployeeOnboard />
          </Suspense>
        ),
      },
      {
        path: 'reports',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Reports />
          </Suspense>
        ),
        children: [],
      },
      {
        path: 'tools',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Tools />
          </Suspense>
        ),
      },
      {
        path: 'quickPrice',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <QuickPrice />
          </Suspense>
        ),
      },
      {
        path: 'admin',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Admin />
          </Suspense>
        ),
      },
      {
        path: 'activity-log',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <ActivityLog />
          </Suspense>
        ),
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default adminRoutes;
